import { get } from 'lodash';

import Flag from '../Flag';

/** General indicator flag */
export default class IndicatorFlag extends Flag {
	_getStyle(args = {}) {
		const returnStyle = this.panel.core.getStyle('flag.indicator');
		const panelStyle = this.panel.params.style;
		const indicatorStyle = this.indicator ? this.indicator.params.style : {};

		// Use indicator color if it exists
		if (indicatorStyle.color) returnStyle.background.color = indicatorStyle.color;

		// Use component style color if it exists
		if (this.indicator.params.componentSeries) {
			// Get proper component where ID's (top, sma, etc.) match
			const component = this.indicator.params.componentSeries.find(row => row.id === args.seriesId);

			if (component && component.styleRef) {
				returnStyle.background.color = get(this.indicator.params.style, component.styleRef).color;
			}
		}

		// Use fallback values if necessary
		if (!returnStyle.font.family) returnStyle.font.family = panelStyle.yAxis.font.family;
		if (!returnStyle.font.size) returnStyle.font.size = panelStyle.yAxis.font.size;

		return {
			...returnStyle,
			...args.style
		};
	}

	/**
	 * Private method to get flag value
	 * @return {number}
	 * @override
	 * @private
	 */
	getValue() {
		if (!this.panel || !this.panel.core.data) return null;

		const { core } = this.panel;

		try {
			const data =
				core.data[core.params.symbol][this.indicator.params.id][
					this.indicator.params.uid
				];
			let dataIndex = data.length - 1;

			// special case: ichimoku series (senkou, kijun etc) have different final indexes
			if (this.indicator.params.id === 'ichimokucloud') {
				const d = data.filter(x => x[this.seriesId] !== undefined);
				dataIndex = d.length - 1;
			}

			return data[dataIndex][this.seriesId];
		} catch (e) {
			core.warn(e.message);
			return null;
		}
	}
	/**
	 * @returns The appropriate event emitter types
	 * @type {object}
	 */
	get eventType() {
		return {
			render: 'FLAG_RENDER_INDICATOR',
			hide: 'FLAG_HIDE_INDICATOR',
			show: 'FLAG_SHOW_INDICATOR'
		};
	}
}
